import React, {useLayoutEffect} from 'react';
import './App.module.scss';
import App from './App';
import unregister from './serviceWorker';
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import theme from './theme';
import { createRoot } from 'react-dom/client';
import { StrictMode } from "react";
import {Auth0Provider, useAuth0} from '@auth0/auth0-react';
import { initDataDog } from "./utils/data-dog";

initDataDog();


const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <StrictMode>
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
        <Auth0Provider
            domain={process.env.REACT_APP_AUTH0_DOMAIN}
            clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
            authorizationParams={{
                redirect_uri: process.env.REACT_APP_AUTH0_REDIRECT_URI,
                audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                connection: process.env.REACT_APP_AUTH0_CONNECTION,
            }}
        >
            <App />
        </Auth0Provider>
  </ThemeProvider>
  </StyledEngineProvider>
  </StrictMode>
)

/** 
 * If you want to start measuring performance in your app, pass a function
 * to log results (for example: reportWebVitals(console.log))
 * or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
 */
unregister();
